import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image", "title", "spinner", "error"]

  show(event) {
    const button = event.currentTarget.closest("[data-photo-url]") || event.currentTarget
    const photoUrl = button.dataset.photoUrl
    const photoName = button.dataset.photoName

    if (!photoUrl) return

    this.titleTarget.textContent = photoName
    this._prepareImage()

    const img = this.imageTarget
    const finish = (success) => {
      img.onload = null
      img.onerror = null
      this._finishLoading(success)
    }

    img.onload = () => finish(true)
    img.onerror = () => finish(false)
    img.alt = photoName
    img.src = photoUrl

    window.bootstrap.Modal.getOrCreateInstance(this.modalTarget).show()
  }

  _prepareImage() {
    this._showSpinner()
    this.imageTarget.classList.add("invisible")
    this.imageTarget.classList.remove("d-none")

    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("d-none")
    }
  }

  _showSpinner() {
    this.spinnerTarget.classList.remove("d-none")
  }

  _finishLoading(success) {
    this.spinnerTarget.classList.add("d-none")

    if (success) {
      this.imageTarget.classList.remove("invisible")
      return
    }

    this.imageTarget.classList.add("d-none")

    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("d-none")
    }
  }
}